// =====================================================
// WeLearn Pro Player - Event module
// =====================================================

import Debug from './util/debugHelper';
import UI from './ui';
import Quiz from './quiz';
import Loader from './loader';
import Progress from './progress';
import urlOptions from './options';
import slide from "./slide";

export default class Events {
    constructor(player) {
        this.player = player;
        this.previousQuiz = 0;
        this.debug = new Debug(this.player.options.debug);

        this._bindEvents();

        this.ui = new UI(this.player);
        this.quiz = new Quiz(this.player);
        this.loader = new Loader(this.player);
        this.progress = new Progress(this.player);
        this.urlOptions = new urlOptions(this.player);
    }

    _bindEvents() {
        $(document).ready((e) => {
            this._bind_listeners();
            this._bind_documentready();
            this._bind_onloadeddata();
            this._bind_timeupdate();
            this._bind_noteEvent();
            this._bind_chatEvent();
        });
    }

    _bind_listeners() {
        let self = this;
        let wlp = this.player;
        let plyr = this.player.plyrPlayer;

        plyr.config.listeners.seek = function disableSeekForUnseekablePlayer (e) {
            if (!wlp.options.seekable) {
                let currentTime = plyr.currentTime;
                let newTime = self._getTargetTime(plyr, e);

                Object.defineProperty(event, "defaultPrevented", {
                    value: event.defaultPrevented,
                    writable: true
                });

                event.preventDefault = () => {
                    event.defaultPrevented = true;
                };

                if ((newTime > currentTime) || (newTime < currentTime)) {
                    e.preventDefault();
                    wlp.seekTo(newTime, true);
                }

                return false;
            }

            return true;
        }
    }

    _bind_documentready() {
        let self = this;

        $(document).on('click', 'span.tick', function () {
            let timeToForward = $(this).data('timestamp');
            self.player.seekTo(timeToForward, true);
        });

        $(window).on("beforeunload", event => {
            if (this.player.options.previewMode === false) {
                this.player.progressData = this.progress.buildProgressData();
                this.progress.updateVideoData(this.player.progressData);
            }
        });
    }

    _bind_chatEvent() {
        let self = this;

        $('#ddlchat').off().on('click', function (e) {
            self.player.chat.getChat();
        });

        /*$('a.btn.btn-main-theme.btn-submit-reply').off().on('click', function (e)
        {
            let courseChatQuestionId = $(e.target).attr('name');

            if ($('#comment-box-' + courseChatQuestionId).val().length)
            {
                self.player.chat.createAnswer(courseChatQuestionId, $('#comment-box-' + courseChatQuestionId).val());
            }
        });*/

        /*$('button.btn.btn-main-theme.btn-submit-question').off().on('click', function (e)
        {
            if ($('#chatQuestion_Message').val().length)
            {
                self.player.chat.createQuestion($('#chatQuestion_Message').val());
                $('#chatQuestion_Message').val("");
            }
        });*/
    }

    _bind_noteEvent() {
        let self = this;

        $('#ddlmemo').off().on('click', function (e) {
            self.player.note.getNote();
        });

        $('#note-area').off().on('keypress', function (e) {
            let noteArea = $(this);

            if (e.which === 13 || e.keyCode === 13) {
                if (noteArea.val().length) {
                    if (wlpVideo.createNote(noteArea.val(), wlpVideo.plyrPlayer.currentTime)) {
                        noteArea.val("");
                        noteArea.blur();
                    } else {
                        e.preventDefault();
                    }
                } else {
                    noteArea.notify("กรุณากรอกข้อความ", "error");
                }
            }
        });

        $('a.btn-main-grey.btn-note-edit').off().on('click', function (e) {
            let noteId = $(e.target).attr('name');

            let oldText = $('li.note-detail#note-' + noteId).find('font.memo-message').text();

            $('li.note-detail#note-' + noteId).find('font.memo-message').replaceWith('<input class="form-control d-inline-block" type=text id="note-edit" name="' + noteId + '" value="' + oldText + '" style="width: 65% !important;">');

            $('.div-note-menu[data-note-id="' + noteId + '"]').css("display", "none");
            $('.div-note-save[data-note-id="' + noteId + '"]').css("display", "block");

            $(".btn-note-save[data-nid='" + noteId + "']").on("click", function (e) {
                self.player.note.updateNote(noteId, $('#note-edit[name=' + noteId + ']').val());
            });

            $(".btn-note-cancel[data-nid='" + noteId + "']").on("click", function (e) {
                self.player.note.getNote();
            });

            $('#note-edit[name=' + noteId + ']').bind('keyup', function (e) {
                e.preventDefault();

                switch (e.key) {
                    case 'Enter':
                        if ($(this).val().length) {
                            self.player.note.updateNote(noteId, $(this).val());
                        } else {
                            $(this).notify("กรุณากรอกข้อความ", "error");
                        }
                        break;

                    case 'Escape':
                        self.player.note.getNote();

                        break;
                }
            });
        });

        /*$('a.btn-main-grey.btn-note-remove').off().on('click', function (e) {
            let noteId = $(e.target).attr('name');

            self.player.note.deleteNote(noteId);
        });*/
    }

    _bind_onloadeddata() {
        let self = this;
        let updateRepeater = {};
        let initEvent = '';

        if (this.player.options.embedVideo === true) {
            initEvent = "ready"
        } else {
            initEvent = "loadeddata";
        }

        this.player.plyrPlayer.on("pause", event => {
            if (this.player.options.previewMode === false) {
                this.player.progressData = this.progress.buildProgressData();
                this.progress.updateVideoData(this.player.progressData);
            }
        });

        this.player.plyrPlayer.on("ended", event => {
            if (this.player.options.previewMode === false) {
                this.player.progressData = this.progress.buildProgressData();
                this.progress.updateVideoData(this.player.progressData);
            }
        });

        this.player.plyrPlayer.on(initEvent, event => {
            // Wrap WeLearn Pro Player to Plyr instance.
            this.ui.bindWlpPlayer();

            // If video player is NOT in Preview Mode, load these:
            if (this.player.options.previewMode === false) {
                // Load user's video progress and test
                this.loader.loadVideoData(this.player.progressData.userId);

                // Parse slide data from slide object
                if (this.player.videoComponent.slide !== undefined) {
                    for (let i = 0; i < this.player.videoComponent.slide.length; i++) {
                        $(`span.tick[data-timestamp='${this.player.videoComponent.slide[i].time}']`).attr('data-page', this.player.videoComponent.slide[i].page);
                    }
                }

                // Parse note data from note object
                if (this.player.progressData.note !== undefined) {
                    for (let i = 0; i < this.player.progressData.note.length; i++) {
                        $(`span.tick[data-timestamp='${this.player.progressData.note[i].time}']`).attr('data-note', this.player.progressData.note[i].noteId);
                    }

                    // Parse test data from test object
                    //for (let i = 0; i < this.player.progressData.note.length; i++)
                    //{
                    //    $(`span.tick[data-timestamp='${this.player.progressData.test[i].time}']`).attr('data-test', this.player.progressData.test[i].testId);
                    //}
                    //for (let i = 0; i < this.player.videoComponent.quiz.length; i++)
                    //{
                    //    $(`span.tick[data-timestamp='${this.player.progressData.quiz[i].time}']`).attr('data-test', this.player.progressData.quiz[i].quizId);
                    //    $(`span.tick[data-timestamp='${this.player.progressData.quiz[i].time}']`).attr('data-csm', this.player.progressData.quiz[i].quizCourseSectionModuleId);
                    //}
                }

                // Start saving video progress after all things ready to use.
                updateRepeater = setInterval(() => {
                        if (this.player.plyrPlayer.playing) //Only update if video is playing
                        {
                            this.player.progressData = this.progress.buildProgressData();
                            this.progress.updateVideoData(this.player.progressData);
                        }
                    },
                    this.player.options.progress.update.interval
                );
            }

            // Apply option from URL
            const urlOptions = this.urlOptions.getOptionsFromUrl();
            for (let [command, value] of Object.entries(urlOptions)) {
                this.urlOptions.applyOption(command, value);
            }
        });
    }

    _getTargetTime(plyr, input) {
        if (
            typeof input === "object" &&
            (input.type === "input" || input.type === "change")
        ) {
            return input.target.value / input.target.max * plyr.media.duration;
        } else {
            return Number(input);
        }
    }

    _bind_timeupdate() {
        let self = this;

        this.player.plyrPlayer.on('loadeddata', event => {
            this.player.plyrPlayer.currentTime = 0; // Temp fix for volumn slider not showing unless manually seek
        });

        this.player.plyrPlayer.on('timeupdate', event => {
            let currentTimestamp = Math.floor(this.player.plyrPlayer.currentTime);
            // Add watched class to watched second
            $('.tick[data-timestamp=' + currentTimestamp + ']').addClass('watched');

            // TODO: Slide correction function. (Need optimization)
            let isSyncSlideEnabled = self.player.syncSlide;
            let hasSlide = self.player.videoComponent.slide;

            if (hasSlide && isSyncSlideEnabled) {
                (function slideSync() {
                    let slideData = self.player.videoComponent.slide;
                    let currentSlide = (function () {
                        let previousSlides = slideData.filter(({ time }) => {
                            return time <= currentTimestamp;
                        });
                        return previousSlides.pop();
                    })();

                    if (currentSlide !== undefined) {
                        self.player.changeSlidePage(currentSlide.page);
                    }
                })();
            }

            {
                /*let slideData = self.player.videoComponent.slide;
                let closestSlide = slideData.reduce(function (prev, curr) {
                    return (Math.abs(curr - slideData.page) < Math.abs(prev - slideData.page) ? curr :prev);
                });
                console.log(closestSlide);*/

                /*if (aheadSlide !== undefined) {
                    self.player.changeSlidePage(aheadSlide.page);
                }*/

                // Sync slide functionality
                // TODO: Intentionally turn this of in favor of new sync slide event in ontimeupdate event
                /*if (this.player.syncSlide) {
                    let pageToChange = $(`.tick[data-timestamp='${currentTimestamp}']`).data('page');
                    if (pageToChange) {
                        this.player.changeSlidePage(pageToChange);
                    }
                    //self.player.changeSlidePage(aheadSlide.page);
                }*/
            }

            let isHasQuiz = $(`span.tick[data-timestamp=${currentTimestamp}]`).data('quiz');
            if (isHasQuiz === undefined) {
                self.previousQuiz = 0;
            }
            let isAlreadyInvoked = (isHasQuiz === self.previousQuiz);

            {
                /*self.debug.log("-------- Quiz invoking log --------");
                self.debug.log({
                    isHasQuiz: isHasQuiz,
                    previousQuiz: self.previousQuiz,
                    isAlreadyInvoked: isAlreadyInvoked
                });*/
            }

            // Invoke test if exists in current timespan
            if (isHasQuiz) {
                self.previousQuiz = isHasQuiz;
                let isInvokeOnce = self.player.options.quiz.invokeOnce;
                let hasInvokedState = $(`span.tick[data-timestamp=${currentTimestamp}]`).data('invoked') !== undefined;

                if ((!hasInvokedState || !isInvokeOnce) && !isAlreadyInvoked) {
                    if (self.player.plyrPlayer.fullscreen.active) {
                        self.player.plyrPlayer.fullscreen.exit()
                    }

                    this.quiz.invokeQuiz($(`span.tick[data-timestamp=${currentTimestamp}]`).data('quiz'), $(`span.tick[data-timestamp=${currentTimestamp}]`).data('csm'));
                    $(`span.tick[data-timestamp=${currentTimestamp}]`).attr('data-invoked', 1);
                }

                self.debug.log("Quiz found: " + $(`span.tick[data-timestamp=${currentTimestamp}]`).data('quiz'));
            }
        });
    }
}
